import { advancedImgTextItem, mainText, normalImgTextItem, posterBlocks, qrCode } from "./poster-long-static";
// 初始化海报文本结构
export const initPosterTextMaps = () => {
  const posterTextMaps = [];
  // 添加主标题块
  posterTextMaps.push(JSON.parse(JSON.stringify(mainText)));
  // 添加普通图文块
  posterTextMaps.push(genPosterBlock("normalImgText"));
  // 添加二维码块
  posterTextMaps.push(JSON.parse(JSON.stringify(qrCode)));
  return posterTextMaps;
}

// 生成海报模块
export const genPosterBlock = (blockName) => {
  const block = posterBlocks.find(item => item.blockName === blockName);
  if (!block) return;
  const posterBlock = JSON.parse(JSON.stringify(block.data));
  // 普通图文默认增加三项文本
  if (posterBlock.blockName === "normalImgText") {
    for (let i = 0; i < 3; i++) {
      const item = JSON.parse(JSON.stringify(normalImgTextItem));
      if (i === 0) {
        // 普通图文第一行文字添加标签样式
        item.content.optionalStyleName = "iconStyleMap";
        item.content.showLabelStyle = true;
        item.content.labelStyle = 1;
      }
      posterBlock.editOptions.items.push(item);
    }
  }
  // 高级图文默认增加三项文本
  if (posterBlock.blockName === "advancedImgText") {
    for (let i = 0; i < 3; i++) {
      posterBlock.editOptions.items.push(JSON.parse(JSON.stringify(advancedImgTextItem)));
    }
  }
  return posterBlock;
}
// 根据模块名找到子项
export const findItemByBlockName = (blockName) => {
  const block = posterBlocks.find(item => item.blockName === blockName);
  if (!block) return;
  const blockItem = JSON.parse(JSON.stringify(block.item));
  return blockItem;
}

// 主副标题的文字样式格式化
export const formatMainTextStyles = (editOptionMap, textStyles) => {
  const styles = [];
  for (let i = 0; i < textStyles.length; i++) {
    const s = textStyles[i] || {};
    if (s.textCountLimit) {
      let arr = s.textCountLimit.split("<x<");
      s.max = parseInt(arr[1]);
      s.min = parseInt(arr[0]);
    }
    styles[i] = {
      ...s,
      showLabelStyle: !!s.labelStyle,
    };
  }
  return {
    subtitle: {
      ...editOptionMap.subtitle,
      ...styles[0],
    },
    title: {
      ...editOptionMap.title,
      ...styles[1],
    },
  };
};

// ==================== 验证相关方法 ====================

/**
 * 验证单个选项的合法性
 * @param {Object} option - 选项对象
 * @returns {boolean} - 是否合法
 */
export const validateOption = (option, fn) => {
  if (option.text !== undefined) {
    const isVali = option.text.length >= option.min && option.text.length <= option.max;
    fn && fn(option, isVali);
    return isVali;
  }
  if (option.src !== undefined) {
    const isVali = !!option.src;
    fn && fn(option, isVali);
    return isVali;
  }
  return true;
};

/**
 * 验证文本映射的合法性
 * @param {Object} textMap - 文本映射对象
 * @returns {boolean} - 是否合法
 */
export const validateTextMap = (textMap, key, fn) => {
  if (key === "floorName" || key === "subtitle" || key === "title") {
    if (!validateOption(textMap, fn)) {
      return false;
    }
  }
  if (key === "items") {// 验证列表子项
    for (const item of textMap) {
      const itemOptions = Object.values(item);
      for (const option of itemOptions) {
        if (!validateOption(option, fn)) {
          return false;
        }
      }
    }
  }
  if (key === "blockContent") {
    for (const option of Object.values(textMap)) {
      if (option.inputType === "multiLine") {
        continue;
      }
      if (!validateOption(option, fn)) {
        return false;
      }
    }
  }
  return true;
};

/**
 * 验证单个块的合法性
 * @param {Object} block - 块对象
 * @returns {boolean} - 是否合法
 */
export const validateBlock = (block, fn) => {
  const keys = Object.keys(block.editOptions);
  for (const key of keys) {
    const textMap = block.editOptions[key];
    const result = validateTextMap(textMap, key, fn)
    if (!result) {
      return false;
    }
  }
  return true;
};

/**
 * 验证所有块的合法性
 * @param {Array} blocks - 块数组
 * @returns {boolean} - 是否全部合法
 */
export const validateAllBlocks = (blocks, fn) => {
  for (const block of blocks) {
    const result = validateBlock(block, fn);
    if (!result) {
      return false;
    }
  }
  return true;
};